import * as Sentry from "@sentry/nextjs";

type ErrorBoundaryName = "application" | "community" | "component" | "global";

interface ErrorBoundaryContext {
  componentStack?: string | null;
  digest?: string;
}

export function reportErrorBoundary(
  error: Error,
  boundary: ErrorBoundaryName,
  context: ErrorBoundaryContext = {},
): void {
  Sentry.captureException(error, {
    tags: { error_boundary: boundary },
    ...(context.componentStack != null
      ? {
          contexts: {
            react: { componentStack: context.componentStack },
          },
        }
      : {}),
    ...(context.digest ? { extra: { digest: context.digest } } : {}),
  });
}
